(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
// ------------------------------------
//
// Shortcuts
//
// ------------------------------------

//posts-loop
(function($) {

	if (typeof window.Shortcuts == 'undefined') window.Shortcuts = {};

	Shortcuts = {



		// ------------------------------------
		// Init
		// ------------------------------------

		init: function() {

			// Guard
			if($('.thechurchco-shortcut').length <= 0) return;

            $('.row .row-title, .shortcut-trigger').click(function(e){



				// Guard Clicking Children
				var $item = $(this);
				if(!$item.hasClass('.row')) $item = $(this).closest('.row');

				$item.toggleClass('-open');

				// Scroll To
				$('html, body').animate({scrollTop: $item.offset().top + 'px'}, 'fast');

            }).children().click(function(e) {return false;});

	    },


	}

	module.exports = Shortcuts;

})(jQuery);

}).call(this,require("rH1JPG"),typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/modules/shortcuts.js","/modules")